import { Pipe, PipeTransform } from '@angular/core';
import { ChargeItemDocumentType } from '../models/charge.models';

@Pipe({
  name: 'docTypeLabel',
  standalone: true
})
export class DocTypeLabelPipe implements PipeTransform {
  transform(value: ChargeItemDocumentType | null | undefined): string {
    if (value == null) return '';
    
    return docTypeLabel(value);
  }
}

export function docTypeLabel(docType: ChargeItemDocumentType): string {
    switch (docType) {
        case "Factura":
            return "N° de factura";
        case "Boleta":
            return "N° de boleta";
        case "Referencia":
            return "N° de referencia";
        case "OC":
            return "Orden de cobro";
        default:
            return docType;
    }
}